import { actions } from '../../../context';
import { useEffect } from 'react';
import { Container, Row } from 'reactstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import './OverviewDashboard.css';
import DashboardConversionActivity from './ConversionActivity/DashboardConversionActivity';
import hasPermission from '../../Shared/hasPermission';
import OpsStats from './OpsStats/OpsStats';
import PracticesStats from './PracticesStats/PracticesStats';
import CommunicationActivity from './CommunicationActivity/CommunicationActivity';

const OverviewDashboard = () => {
    const dispatch = useDispatch();
    const permissions = useSelector((state)=>state.auth.permissions, shallowEqual);
    const canSeeCurrStats = hasPermission(`DashboardCurrentStats`, permissions);
    const canSeeOpsStats = hasPermission(`DashboardOpsStats`, permissions);
    const canSeeConversionActivity = hasPermission(`DashboardConversionActivity`, permissions);
    const canSeeGlobalComms = hasPermission(`DashboardGlobalCommunications`, permissions);

    const totalCount = useSelector((state)=>state.practice.dashboardInfo?.totalCount);
    const isInfo = totalCount >= 0;

    useEffect(() => {
        // only request the data the user is actually permitted to see
        const requests = [dispatch(actions.practice.getDashboardStats())];
        if (canSeeGlobalComms) requests.push(dispatch(actions.communication.fetchCommunicationActivity()));
        if (canSeeConversionActivity) requests.push(dispatch(actions.conversions.fetchConversionOverview()));
        Promise.all(requests);
    }, [dispatch, canSeeGlobalComms, canSeeConversionActivity]);

    return (
        <Container id="dashboard" className='my-4 ov-dashboard'>

            {!isInfo &&
                <Row className='p-5 sc-glass text-light sc-rounded'>
                    <div className="text-center mx-auto">
                        <h1 className="d-none d-md-block">Loading dashboard...</h1>
                        <h4 className="d-md-none">Loading dashboard...</h4>
                        <div className="mx-auto my-3 loading-spinner spin-animate"></div>
                    </div>
                </Row>
            }

            {isInfo && canSeeCurrStats && (
                <PracticesStats />
            )}

            {isInfo && (
                <Row className='text-light sc-rounded mb-4'>

                    {canSeeGlobalComms && (
                        <CommunicationActivity />
                    )}

                    {canSeeConversionActivity && (
                        <div className="w-50 pl-2">
                            <DashboardConversionActivity />
                        </div>
                    )}
                </Row>
            )}

            {isInfo && canSeeOpsStats && (
                <OpsStats />
            )}
        </Container>
    );
};

export default OverviewDashboard;
